/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mapping_System_GxoInputs */

const en_mapping_system_gxo = /** @type {(inputs: Mapping_System_GxoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GXO`)
};

/**
* | output |
* | --- |
* | "GXO" |
*
* @param {Mapping_System_GxoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const mapping_system_gxo = /** @type {((inputs?: Mapping_System_GxoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mapping_System_GxoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_mapping_system_gxo(inputs)
});